import React from 'react';

import VerticalNavMenuLink from './VerticalNavMenuLink';
import VerticalNavMenuGroup from './VerticalNavMenuGroup';
import VerticalNavMenuSectionHeader from './VerticalNavMenuSectionHeader';

// ** Utils
import {
  canViewMenuGroup,
  resolveVerticalNavMenuItemComponent as resolveNavItemComponent
} from '../../../utils';

const VerticalMenuNavItems = props => {
  // ** Components Object
  const Components = {
    VerticalNavMenuLink,
    VerticalNavMenuGroup,
    VerticalNavMenuSectionHeader
  };

  // ** Render Nav Menu Items
  const RenderNavItems = props.items?.map((item, index) => {
    const TagName = Components[resolveNavItemComponent(item)];
    let WrapperComponent = React.Fragment;
    let hasWrapper = false;
    if (item.wrapper) {
      WrapperComponent = item.wrapper;
      hasWrapper = true;
    }
    if (item.children) {
      return canViewMenuGroup(item) && (
        <WrapperComponent
          key={item.id}
          {...(hasWrapper && {
            item: item
          })}
        >
          <TagName
            item={item}
            index={index}
            key={item.id}
            {...props}
          />
        </WrapperComponent>
      );
    }
    return (
      <WrapperComponent
        key={item.id}
        {...(hasWrapper && {
          item: item
        })}
      >
        <TagName
          key={item.id || item.header}
          item={item}
          {...props}
        />
      </WrapperComponent>
    );
  });

  return RenderNavItems;
};

export default VerticalMenuNavItems;
